<template>
	<div>
		<h1>404</h1>
		<h5>{{$t('Page not found!')}}</h5>
	</div>
</template>

<script>
	export default {}
</script>